/**
 * FeedbackFormSort
 */
export enum FeedbackFormSort {
    RECENT = 'recent',
    ALPHABETICAL = 'alphabetical'
}
